import React, { useState, useEffect } from 'react';
import { Radio, Form, DatePicker } from 'antd';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { SLOTS, PROVIDERLIST } from '../../../core-units/constants/actionTypes';
import agent from '../../../agent';
import '../home-page.css';
import _ from 'lodash';

const dateFormat = 'YYYY-MM-DD';

const StepAppointment = (props) => {
  const dispatch = useDispatch();
  const { schedule, provider } = useSelector((state) => state.services);

  const [service, setService] = useState({});
  const [product, setProduct] = useState({});
  const [coupon, setCoupon] = useState({});
  const [total, setTotal] = useState(0);
  const [providerId, setProviderId] = useState(1);
  const [date, setDate] = useState(
    localStorage.getItem('date')
      ? dayjs(localStorage.getItem('date'))
      : dayjs().format(dateFormat)
  );
  const [time, setTime] = useState(dayjs().format('HH:mm:ss'));
  const [currentDate, setCurrentDate] = useState(new Date());
  const [timePro, setTimePro] = useState([]);
  const [providerSlotsMap, setProviderSlotsMap] = useState({});
  const [selectedProviderId, setSelectedProviderId] = useState(null);

  // useEffect(() => {
  //   getTimeSlots(dayjs(date, dateFormat).format(dateFormat));

  //   const retrieveService = localStorage.getItem('service');
  //   const retreveProduct = localStorage.getItem('product');

  //   setDate(
  //     localStorage.getItem('date')
  //       ? dayjs(localStorage.getItem('date'))
  //       : dayjs().format(dateFormat)
  //   );
  //   setService(!_.isEmpty(retrieveService) ? JSON.parse(retrieveService) : {});
  //   setProduct(!_.isEmpty(retreveProduct) ? JSON.parse(retreveProduct) : {});
  //   setCoupon(localStorage.getItem('couponData'));
  //   setTotal(localStorage.getItem('total'));
  //   setTime(localStorage.getItem('time'));
  // }, []);

  useEffect(() => {
  const retrieveService = localStorage.getItem("service");
  const retreveProduct = localStorage.getItem("product");

  const parsedService = retrieveService ? JSON.parse(retrieveService) : {};
  const parsedProduct = retreveProduct ? JSON.parse(retreveProduct) : {};

  setService(parsedService);
  setProduct(parsedProduct);
  setCoupon(localStorage.getItem("couponData"));
  setTotal(localStorage.getItem("total"));
  setTime(localStorage.getItem("time"));

  // set date
  setDate(
    localStorage.getItem("date")
      ? dayjs(localStorage.getItem("date"))
      : dayjs().format(dateFormat)
  );
}, []);

// run after service is available
useEffect(() => {
  if (service && service.id) {
    getTimeSlots(dayjs(date, dateFormat).format(dateFormat));
  }
}, [service, date]);

  const disabledDate = (current) => {
    return current && current < dayjs().endOf('day');
  };

  const onChange = (date, dateString) => {
    if (dateString) {
      getTimeSlots(dateString);
    }
    setDate(date);
    localStorage.setItem('date', dateString);
  };

  const getTimeSlots = (date) => {
    const providerSlotsMap = {};    
    dispatch({
      type: PROVIDERLIST,
      payload: agent.Services.provider_list(''),
      callback: (value) => {
        _.map(_.get(value, 'data'), (each) => {
          let requestParams = {
            service_id: service.id,
            date: date,
            provider_id: _.get(each, 'id'),
          };
          dispatch({
            type: SLOTS,
            payload: agent.Services.schedule(requestParams),
            callback: (valu) => {
              providerSlotsMap[_.get(each, 'id')] = valu;
              const array = Object.values(providerSlotsMap).flat();
              const uniqueData = [...new Set(array)];
              const removeDuplicates = (data, key) => {
                return [...new Map(data.map((item) => [key(item), item])).values()];
              };
              uniqueData.sort((a, b) => {
                return dayjs(a.time, 'HH:mm') - dayjs(b.time, 'HH:mm');
              });
              setTimePro(removeDuplicates(uniqueData, (item) => item.time));
              setProviderSlotsMap(providerSlotsMap);
            },
          });
        });

        const ids = _.chain(_.get(value, 'data')).map('id').value();
        setProviderId(ids);
        localStorage.setItem('providerId', ids);
      },
    });
  };

  const onTimeChange = (e) => {
    props.AppvalidationHandler();
    const selectedTime = e.target.value;

    let selectedProviderId = null;
    for (const providerId in providerSlotsMap) {
      const slots = providerSlotsMap[providerId];
      if (slots.some((slot) => slot.time === selectedTime)) {
        selectedProviderId = providerId;
        break;
      }
    }

    setTime(selectedTime);
    setSelectedProviderId(selectedProviderId);
    localStorage.setItem('time', selectedTime);
    if (selectedProviderId) {
      localStorage.setItem('selectedProviderId', selectedProviderId);
    }
  };

  const timeSlots = () => {
    const slots = timePro ? timePro : schedule;
    if (!_.isEmpty(slots)) {
      return (
        <Radio.Group defaultValue={time} onChange={onTimeChange} buttonStyle="solid">
          {_.map(slots, ( (val, key)=> {
            if (_.get(val, 'time')) {
              return (
                <Radio.Button value={val.time} key={key}>
  {dayjs(_.get(val, 'time'), 'HH:mm').format('h.mm A')}
                </Radio.Button>
              );
            }
          })
          )}
        </Radio.Group>
      );
    } else if (!_.isEmpty(time)) {
      return (
        <Radio.Button value={dayjs(time, 'HH:mm').format('h.mm A')} key={time}>
          {dayjs(time, 'HH:mm').format('h.mm A')}
        </Radio.Button>
      );
    } else {
      return <span>No slots Available</span>;
    }
  };

  return (
    <div className="InspectionStepsContainer">
      <div className="StepAppointmentInfo">
        <div className="PricingAddOnTitle">Book your Appointment</div>
        <div className="InspectionStepTitle">
          {_.get(service, 'name')} <b>$ {_.get(service, 'price')}</b>
          {_.map(product, function (val, key) {
            return (
              <React.Fragment key={key}>
                + {_.get(val, 'name')} <b>$ {_.get(val, 'price')}</b>
              </React.Fragment>
            );
          })}
        </div>
        <div className="CouponCodeTotal">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-2">
              <div className="CouponCodeTotalSection">
                <span>Total</span>
                <span className="CouponCodeTotalAmount">$ {total}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="StepsFormCardContainer">
          <div className="row justify-content-center">
            <div className="col-12 col-md-12 col-lg-6">
              <div className="StepsFormCard">
                <Form className="row">
                  <Form.Item className="col-12 col-md-12 mb-2" label="Select Date">
                    <DatePicker
                      disabledDate={disabledDate}
                      defaultValue={dayjs(date, dateFormat)}
                      format={dateFormat}
                      onChange={onChange}
                    />
                  </Form.Item>
                  <Form.Item
                    className="col-12 col-md-12 TimeRadioGroup"
                    label="Pick Time"
                  >
                    {timeSlots()}
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepAppointment;
